import React, { useContext } from "react";
import "./Left.scss";
import MyContext from "../../Uttis/MyContext";
import PDF from "./Pdf"; // Array of PDFs

const Left = () => {
  const { showLeft, closeLeft } = useContext(MyContext);

  if (!showLeft) return null;

  return (
    <div className="left-modal">
      {/* Overlay Layer */}
      <div className="overlay" onClick={closeLeft}></div>

      {/* Modal Content */}
      <div className="modal-content animate">
        <div className="modal-header">
          <h2>Download PDF</h2>
          <button className="close-btn" onClick={closeLeft} aria-label="Close">
            &times;
          </button>
        </div>

        {/* PDF Buttons */}
        <div className="pdf-list">
          {PDF.map((item, index) => (
            <a
              key={index}
              href={item.pdf}
              className="pdf-btn"
              download={item.name}
            >
              {item.name}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Left;
